/* eslint global-require: "off" */

const images = {
  behaviorSpanLogo: require('./Images/behavior_span.png'),
  databasedLogo: require('./Images/databased_logo.svg').default,
  dunderMifflinLogo: require('./Images/dunder-mifflin.png'),
  downloadIcon: require('./Images/download_icon.png'),
  github: require('./Images/github_icon.png'),
  ivaCorpLogo: require('./Images/iva_logo.svg').default,
  linkedIn: require('./Images/linkedin_icon.png')
}

export default images
